class VMDetectionInvigilatorModal {
    /**
     * Constructor for VMDetectionInvigilatorModal class.
     * Initializes the class with necessary services and sets up event listeners.
     * 
     * @param {Object} $scope - AngularJS scope object.
     * @param {Object} EventLogBridgeService - Service for logging events.
     * @param {Object} AuthenticationBridgeService - Service for authentication.
     * @param {Object} LogBridgeService - Service for logging messages.
     * @param {Object} $timeout - AngularJS $timeout service.
     * @param {Object} $signals - Service for handling signals.
     * @param {Object} $uibModalInstance - Instance of the modal.
     * @param {Object} $location - AngularJS $location service.
     * @param {Object} $translate - AngularJS $translate service.
     */
    constructor($scope, EventLogBridgeService, AuthenticationBridgeService, LogBridgeService, $timeout, $signals, $uibModalInstance, $location, $translate) {
        this.$scope = $scope;
        this.$logger = LogBridgeService;
        this.$authentication = AuthenticationBridgeService;
        this.$eventLog = EventLogBridgeService;
        this.$timeout = $timeout;
        this.$signals = $signals;
        this.$uibModalInstance = $uibModalInstance;
        this.$location = $location;
        this.$translate = $translate;

        this.$scope.invigilatorUnlockFailed = false;
        this.$scope.eventLogMessage = this.$translate.instant("MODULES.VM-DETECTION.EVENTLOG-INVIGILATOR-MESSAGE");

        // Bind the onInvigilatorUnlock method to the current instance
        this.$scope.onInvigilatorUnlock = this.onInvigilatorUnlock.bind(this);

        // Set up event listeners for authentication signals
        this.$signals.on("tryInvigilatorAuthenticationFailed", this._tryInvigilatorAuthenticationFailed.bind(this));
        this.$signals.on("tryInvigilatorAuthenticationSuccess", this._tryInvigilatorAuthenticationSuccess.bind(this));
    }

    /**
     * Handles the invigilator unlock attempt.
     * Calls the authentication service with provided codes.
     */
    onInvigilatorUnlock() {
        this.$authentication.tryInvigilatorAuthenticationWithAllCodes(
            this.$scope.invigilatorCode,
            this.$scope.schoolCode,
            this.$scope.unlockCode
        );
    }

    /**
     * Handles the invigilator authentication failure.
     * Logs the failure event after a timeout.
     * 
     * SMELL: The use of $timeout here might not be necessary. Consider if it's truly needed for the delay.
     */
    _tryInvigilatorAuthenticationFailed() {
        this.$timeout(() => {
            this.logUnlockEvent(true);
        });
    }

    /**
     * Logs the unlock event.
     * 
     * @param {boolean} isInvigilator - Indicates if the event is for an invigilator.
     */
    logUnlockEvent(isInvigilator) {
        this.$scope.invigilatorUnlockCodeInputDisabled = false;
        const eMsg = this.$translate.instant('MODULES.VM-DETECTION.EVENTLOG-INVIGILATOR-UNLOCK-FAILED');

        if (isInvigilator) {
            this.$eventLog.logEvent(eMsg, 'invLoginFailed', this.$scope.eventLogMessage, '', {});
            this.$logger.warn("VM-Detection: Invigilator Access not granted, wrong Credentials");
        } else {
            this.$eventLog.logEvent(eMsg, 'invLoginFailed', this.$translate.instant('MODULES.VM-DETECTION.EVENTLOG-INVIGILATOR-UNLOCK-WRONG-SUCCESS'), '', {});
            this.$logger.warn("VM-Detection: Invigilator Access not granted, no Invigilator Code entered, maybe candidate");
        }

        this.$scope.invigilatorUnlockCode = null;
        this.$scope.invigilatorUnlockFailed = true;
    }

    /**
     * Handles the invigilator authentication success.
     * Logs the success event and closes the modal after a timeout.
     * 
     * @param {string} data - JSON string containing the authentication result.
     * 
     * SMELL: The use of $timeout here might not be necessary. Consider if it's truly needed for the delay.
     */
    _tryInvigilatorAuthenticationSuccess(data) {
        this.$timeout(() => {
            const result = JSON.parse(data);
            if (angular.isObject(result) && result.type === 'invigilator') {
                this.$signals.remove("tryInvigilatorAuthenticationFailed");
                this.$signals.remove("tryInvigilatorAuthenticationSuccess");

                const eventMsg = this.$translate.instant('MODULES.VM-DETECTION.EVENTLOG-INVIGILATOR-UNLOCK-SUCCESS');

                this.$eventLog.logEvent(eventMsg, 'vmAllowed', this.$scope.eventLogMessage, '', {});
                this.$logger.info("VM-Detection: Invigilator Login granted");

                this.$uibModalInstance.close();
                this.$location.path("/login");
            } else {
                this.logUnlockEvent(false);
            }
        });
    }
}

export default VMDetectionInvigilatorModal;